import { create } from "zustand";

const useNotebookStore = create((set) => ({
  notebookList: [],
  cards: [],
  viewingNotebook: null,
  editingNotebook: null,
  cardTitle: "",
  hasUnsavedChanges: false,
  isEditing: false,

  setNotebookList: (list) => set({ notebookList: list }),
  setCards: (cards) => set({ cards }),
  setViewingNotebook: (id) => set({ viewingNotebook: id }),
  setEditingNotebook: (id) => set({ editingNotebook: id, isEditing: id !== null }),
  setCardTitle: (title) => set({ cardTitle: title }),
  setHasUnsavedChanges: (status) => set({ hasUnsavedChanges: status }),
}));

export default useNotebookStore;